<template>
  <div>
    <v-layout row wrap class="mb-4">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
    </v-layout>
    <v-card>
      <v-card-title>
        <div>
          <h3 class="headline mb-0">{{labels.payment}}</h3>
        </div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs12>
              <message :messages="messages"></message>
            </v-flex>
            <v-flex lg6 xs12>
              <v-autocomplete :items="paytModeList" v-model="fireForm.paytMode" :label="labels.paytMode" item-text="label" item-value="value" data-vv-name="paytMode" :data-vv-as="labels.paytMode" :error-messages="errors.collect('paytMode')" v-validate="'required'"></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12>
            </v-flex>
            <template v-if="fireForm.paytMode === 'CC'">
              <v-flex lg6 xs12>
                <v-text-field ref="paytCCNo" v-creditcard-mask key="paytCCNo" :prepend-icon="ccIcon" v-model="paytCCNo" :label="labels.paytCCNo" :error-messages="errors.collect('paytCCNo')" data-vv-name="paytCCNo" :data-vv-as="labels.paytCCNo" v-validate="'required|credit_card'"></v-text-field>
              </v-flex>
              <v-flex lg6 xs12>
                <v-text-field key="paytCCName" prepend-icon="mdi-account-card-details" v-model="fireForm.paytCCName" :label="labels.paytCCName" :error-messages="errors.collect('paytCCName')" data-vv-name="paytCCName" :data-vv-as="labels.paytCCName" v-validate="'required|max:100'"></v-text-field>
              </v-flex>
              <v-flex lg6 xs12>
                <v-text-field ref="paytExpDate" v-creditcard-exp-mask key="paytExpDate" prepend-icon="mdi-calendar" persistent-hint hint="MM-YYYY" v-model="paytExpDate" :label="labels.paytExpDate" :error-messages="errors.collect('paytExpDate')" data-vv-name="paytExpDate" :data-vv-as="labels.paytExpDate" v-validate="'required|credit_card_exp'"></v-text-field>
              </v-flex>
              <v-flex lg6 xs12>
                <v-text-field key="paytCCCvv" v-int-mask="{intScale: 5}" type="tel" prepend-icon="mdi-textbox-password" v-model="fireForm.paytCCCvv" :label="labels.paytCCCvv" :error-messages="errors.collect('paytCCCvv')" data-vv-name="paytCCCvv" :data-vv-as="labels.paytCCCvv" v-validate="'required|max:5|numeric'"></v-text-field>
              </v-flex>
            </template>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-layout row wrap class="mt-3">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="secondary" dark type="submit" :loading="quotation.saving" @click.prevent="doInForceProposal">
        In-Force Proposal
        <v-icon right dark>mdi-arrow-right-bold-box</v-icon>
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
import { AGENCY_QUOTATION_LIFECYCLE, QUOTE_FIRE_PAYMENT, AGENCY_QUOTATION_SAVE_LOADING, AGENCY_QUOTATION_SAVE_SUCCESS, AGENCY_QUOTATION_SAVE_FAIL, AGENCY_QUOTATION_LEAVEQUOTE } from '@/store/types'
import MessageMixin from '@/mixins/message'
import { SaveQuoteMixin } from '../../shared/saveQuoteMixin'
import { PaymentMixin } from '../../shared/paymentMixin'
import { paymentMode } from '@/const/underwriting/fire'
import { generalFireForm } from '@/store/modules/agency/actions/quote'

export default {
  data() {
    return {
      fireForm: {
        // Contains values for submit
        paytMode: undefined,
        paytCCNo: undefined,
        paytCCName: undefined,
        paytCCType: undefined,
        paytCCExpMth: undefined,
        paytCCExpYr: undefined,
        paytCCCvv: undefined,
        paytInstalmentPlan: undefined
      }
    }
  },
  computed: {
    globalCommonForm() {
      return this.$store.state.agency.quotation.commonForm
    },
    quotation() {
      return this.$store.state.agency.quotation
    },
    paytModeList() {
      let result = []
      Object.keys(paymentMode).forEach(function (key) {
        const status = paymentMode[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    }
  },
  methods: {
    doInit() {
      // Default value from vuex store 1st
      this.fireForm.paytMode = this.globalCommonForm.paytMode
      this.fireForm.paytCCNo = this.globalCommonForm.paytCCNo
      this.paytCCNo = this.globalCommonForm.paytCCNo
      this.fireForm.paytCCName = this.globalCommonForm.paytCCName
      this.fireForm.paytCCType = this.globalCommonForm.paytCCType
      this.fireForm.paytCCExpMth = this.globalCommonForm.paytCCExpMth
      this.fireForm.paytCCExpYr = this.globalCommonForm.paytCCExpYr
      this.fireForm.paytCCCvv = this.globalCommonForm.paytCCCvv

      if (this.fireForm.paytMode === undefined || this.fireForm.paytMode === null) {
        if (this.paytModeList.length > 0) {
          this.fireForm.paytMode = this.paytModeList[0].value
        }
      }

      if (this.fireForm.paytCCExpMth && this.fireForm.paytCCExpYr) {
        this.formatExpDate(this.fireForm.paytCCExpMth, this.fireForm.paytCCExpYr)
      }
    },
    doBack() {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 4)
      this.$router.push({ name: 'fireQuotePremium' })
    },
    doInForceProposal() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.doProcessForm()
          this.$store.commit(QUOTE_FIRE_PAYMENT, this.fireForm)
          this.proceessInforce()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doPartialSave() {
      try {
        this.doProcessForm()
        this.$store.commit(QUOTE_FIRE_PAYMENT, this.fireForm)
        await this.$store.dispatch('saveQuote')
        return true
      } catch (err) {
        return false
      }
    },
    doProcessForm() {
      // CC Type
      if (this.fireForm.paytMode === 'CC') {
        this.fireForm.paytCCType = this.backEndCCTypeFormat()

        // UnMask
        this.$refs.paytCCNo.$el.cleave.setRawValue(this.paytCCNo)
        this.fireForm.paytCCNo = this.$refs.paytCCNo.$el.cleave.getRawValue()

        if (this.paytExpDate) {
          this.fireForm.paytCCExpMth = null
          this.fireForm.paytCCExpYr = null
          const splitArr = this.paytExpDate.split('-')
          if (splitArr && splitArr.length === 2) {
            if (splitArr[0].length === 2 && splitArr[1].length === 4) {
              this.fireForm.paytCCExpMth = Number(splitArr[0])
              this.fireForm.paytCCExpYr = Number(splitArr[1])
            }
          }
        }
      } else {
        this.fireForm.paytCCNo = undefined
        this.fireForm.paytCCName = undefined
        this.fireForm.paytCCType = undefined
        this.fireForm.paytCCExpMth = undefined
        this.fireForm.paytCCExpYr = undefined
        this.fireForm.paytCCCvv = undefined
      }
    },
    async proceessInforce() {
      const apiUrl = this.quotation.menu.inForce
      if (apiUrl) {
        try {
          this.$store.commit(AGENCY_QUOTATION_SAVE_LOADING)
          const result = await this.$http.post(apiUrl, generalFireForm(this.$store.state.agency))
          this.$store.commit(AGENCY_QUOTATION_SAVE_SUCCESS)
          this.$snotify.success('Proposal has been In-Forced')

          this.$store.commit(AGENCY_QUOTATION_LEAVEQUOTE)
          this.$router.push({ name: 'fireQuoteQuery', params: { id: result.data.proposalNo }, query: { if: true } })
        } catch (err) {
          if (err.response && err.response.data) {
            this.fullMessage(err.response.data)
          }
          // We need this to stop the loading (err msg will be displayed directly)
          this.$store.commit(AGENCY_QUOTATION_SAVE_FAIL, {})
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    }
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.agency.quotation.quoteLifeCycle !== 5) {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 5)
    }
    this.doInit()
  },
  mixins: [
    MessageMixin,
    SaveQuoteMixin,
    PaymentMixin
  ]
}
</script>

<style>
</style>
